import { Grid, Typography } from '@mui/material';
import { usePqrDataSfc } from './hook';
import { PqrDataSfcProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const PqrDataSfc = (props: PqrDataSfcProps) => {
    const {
        formik,
        channelPresentsFailures,
        controlEntities,
        receptionInstances,
        receptionPoints,
        admissions,
        isAdmission,
        isRequest,
        isSfc,
    } = usePqrDataSfc(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Datos PQR SFC
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(channelPresentsFailures)}
                    label="Canal qué presentó falla"
                    name="channelPresentsFailure"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.channelPresentsFailure}
                    errors={formik.errors.channelPresentsFailure}
                    value={formik.values.channelPresentsFailure}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('channelPresentsFailure', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(controlEntities)}
                    label="Ente de control"
                    name="controlEntity"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.controlEntity}
                    errors={formik.errors.controlEntity}
                    value={formik.values.controlEntity}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('controlEntity', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(receptionInstances)}
                    label="Instancia de recepción"
                    name="receptionInstance"
                    size="small"
                    required
                    disabled={isRequest && isSfc}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionInstance}
                    errors={formik.errors.receptionInstance}
                    value={formik.values.receptionInstance}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionInstance', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(receptionPoints)}
                    label="Punto de recepción"
                    name="receptionPoint"
                    size="small"
                    required
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionPoint}
                    errors={formik.errors.receptionPoint}
                    value={formik.values.receptionPoint}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionPoint', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(admissions)}
                    label="Admisión"
                    name="admission"
                    size="small"
                    required
                    disabled={isAdmission}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.admission}
                    errors={formik.errors.admission}
                    value={formik.values.admission}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('admission', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="¿Es una queja express?"
                    checked={Boolean(formik.values.hasExpressComplaint)}
                    onBlur={formik.handleBlur}
                    disabled
                />
            </Grid>
        </Grid>
    );
};
